const IFrame = require('app/ui/modal/IFrame');

class ModalShow {
    defaultOptions() {
        return {
            'selector': '.btn-order-show',
            'selectorReajust': '.btn-reajust-show',
			'dataIdSelector': 'orderid', 
        };
    }

    constructor() {
        this.settings = $.extend(this.defaultOptions());

        this.linkSelector = this.settings.selector;
        this.linkSelectorReajust = this.settings.selectorReajust;
        this.dataIdSelector = this.settings.dataIdSelector;

        this.initialize();
    }

    initialize() {
        var self = this;
        
		this.initializeOrderClick();
    }

	initializeOrderClick(){
		var dataIdSelector = this.dataIdSelector;
        $('body').on('click',this.linkSelector,function(){
            let $btn = $(this);
            let modal = new IFrame({
				'modalSize': 'full',
                'url': '/order/' + $btn.data(dataIdSelector) + '/show/',
            });

            modal.show();
			
			return false;
		});
		
        $('body').on('click',this.linkSelectorReajust,function(){
            let $btn = $(this);
            let modal = new IFrame({
				'modalSize': 'full',
                'url': '/order/' + $btn.data(dataIdSelector) + '/reajust/',
            });

            modal.show();
			
			return false;
		});
	}

}

module.exports = ModalShow;